<template>
    <div v-if="showBrowserCookie" id="cookie-browser" class="accept-cookie" :class="{'smassCookie': smassCookie}">
        <v-container class="no-padding-left no-margin-left">
            <v-layout row wrap>
                <v-flex sm9 xs12>
                    <div>
                        <span>{{text('api.browserCookie.acceptance.text', [currentBrowser])}}
                            <a @click="showBrowsersListPopup()">{{text('api.browserCookie.browsersList')}}</a>
                        </span>
                    </div>
                </v-flex>
                <v-flex sm3 xs12 >
                    <v-btn class="color-on-primary-text" color="primary" @click="acceptDetectBrowserCookie()">{{text('api.cookie.acceptance.button')}}</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <browsers-list-popup></browsers-list-popup>
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import BrowsersListPopup from '../../../common/components/shared/BrowsersListPopup';
import Bowser from "bowser";

export default {
        name: "DetectBrowserCookie",
        components: {
            BrowsersListPopup
        },
        data () {
            return {
                currentBrowser: '',
                showBrowserCookie: false,
                smassCookie: false,
                acceptedCookie: false
            }
        },
        computed: {
            ...mapGetters({
                getMustShowBrowsersListPopup: 'TranslationStore/getMustShowBrowsersListPopup',
                getVerifiedBrowsers: 'TranslationStore/getVerifiedBrowsers',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            }),
        },

        methods: {
                ...mapActions({
                    showBrowsersListPopup: 'TranslationStore/showBrowsersListPopup'
                }),

                acceptDetectBrowserCookie() {

                    /* SET COOKIE FOR ACCEPTANCE */
                    function setCookie(name, value, days) {
                        let expires = "";
                        if (days) {
                            let date = new Date();
                            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                            expires = "; expires=" + date.toUTCString();
                        }
                        document.cookie = name + "=" + (value || "") + expires + "; path=/";
                    }

                    setCookie('browser-cookie', this.currentBrowser, 366);

                    this.showBrowserCookie = false;

                },
                aboutCookies() {
                    this.$router.push('/regulatory');
                }
            },
        mounted() {
            const browser = Bowser.getParser(window.navigator.userAgent);

            let browserName = browser.getBrowserName();
            let browserVersion = browser.getBrowserVersion();
            let browserOSName = browser.getOSName();
            let browserOSVersion = browser.getOSVersion();
            let browserOS = browserOSName + " " + browserOSVersion;

            /* DO NOT REMOVE THE LOGS !!! Needed for browser identification */
            console.log("browserName = " + browserName);
            console.log("browserVersion = " + browserVersion);
            console.log("browserOS = " + browserOS);

            this.currentBrowser = browserName + "/" + browserVersion;

            let readCookieFunction = (function () {
                return {
                    getCookie: function (name) {
                        let value = "; " + document.cookie;
                        let parts = value.split("; " + name + "=");
                        if (parts.length === 2) {
                            return parts.pop().split(";").shift();
                        }
                    }
                }
            })();

            /* add class dynamically to display cookie div */
            let smassCookie = readCookieFunction.getCookie('smass-cookie');
            if (smassCookie !== undefined) {
                this.smassCookie = true;
            }

            let cookieValue = readCookieFunction.getCookie('browser-cookie');

            // if the user already accepted that he is using a version of
            // browser that is not tested don't show the popup again
            if (cookieValue === this.currentBrowser) {
                this.showBrowserCookie = false;
                // TODO move verify browser logic into a method
                return;
            }

            // If the App Property: DISABLE_DISRUPTOR_BROWSER is set to true then don't show the browser cookie
            let mustShowBrowserCookieConfirm = this.getAppPropertyValue('DISABLE_DISRUPTOR_BROWSER') === "true" ? false : true;

            if (!mustShowBrowserCookieConfirm) {
                this.showBrowserCookie = false;
                return;
            }

            // check to see if the browser he is using is in the list of verified browsers.
            // findIndex will return -1 if the browser used is not in the list of verified browsers
            let currentBrowserIndex = this.getVerifiedBrowsers.browsers.findIndex((element)=>{
                return element.browser === browserName;
            });

            // if the browser used is not found then show the info cookie
            if (currentBrowserIndex === -1) {
                this.showBrowserCookie = true;
            }
            else {
                // check to see if the version of the browser is in the verified browsers list
                let verifiedBrowserVersionIndex = -1;
                let verifiedBrowserVersions = this.getVerifiedBrowsers.browsers[currentBrowserIndex].versions;
                for (let i = 0; i < verifiedBrowserVersions.length; i++) {
                    verifiedBrowserVersionIndex = verifiedBrowserVersions[i].version.findIndex((element) => {
                        return element === browserVersion;
                    });
                    if(verifiedBrowserVersionIndex !== -1) {
                        break;
                    }
                }

                if (verifiedBrowserVersionIndex === -1) {
                    this.showBrowserCookie = true;
                }
                else {
                    this.showBrowserCookie = false;
                }
            }

        }

    }
</script>



// WEBPACK FOOTER //
// src/common/components/cookies/DetectBrowserCookie.vue